import { Link } from "react-router-dom";
import type { Service } from "@/config/services";
import { CATEGORY_LABELS } from "@/config/services";
import { waMessages } from "@/lib/whatsapp";
import MediaImage from "./MediaImage";
import WhatsAppLink from "./WhatsAppLink";

export default function ServiceCard({ service }: { service: Service }) {
  return (
    <article className="group flex flex-col rounded-lg border border-background-300/60 bg-background-50 overflow-hidden">
      <Link
        to={`/hizmetler/${service.slug}`}
        className="block overflow-hidden"
        aria-label={`${service.name} detayları`}
      >
        <div className="aspect-[4/5] w-full overflow-hidden bg-background-200">
          <MediaImage
            src={service.image}
            alt={service.alt}
            className="h-full w-full transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <span className="text-[11px] uppercase tracking-[0.18em] text-accent-600">
          {CATEGORY_LABELS[service.category]}
        </span>
        <h3 className="mt-2 font-heading text-2xl leading-tight text-primary-800">
          <Link to={`/hizmetler/${service.slug}`} className="hover:text-accent-600 transition-colors">
            {service.name}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{service.short}</p>

        <div className="mt-auto flex flex-col gap-2 pt-4">
          <Link
            to={`/hizmetler/${service.slug}`}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-800 transition-colors hover:text-accent-600"
          >
            Detayları İncele
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
          <WhatsAppLink
            message={waMessages.serviceInfo(service.name)}
            label="WhatsApp'tan Bilgi Al"
            variant="whatsapp"
            size="sm"
            sourceSection="service_card"
            serviceId={service.id}
            className="w-full"
          />
        </div>
      </div>
    </article>
  );
}